export enum PlanType {
    Express = 'Express',
    Enterprise = 'Enterprise',
    Core = 'Core'
}
